import { Component } from '@angular/core';
import { DynamicFormService, FORM_SERVICE_PROVIDER_TOKEN } from '@ntap/common';
import {
  InputComponentUtil,
  InputControlData,
  ItemView,
  ItemViewProviderDirective,
  NotificationService
} from '@ntap/core';
import { PrimeNGCommonItemViewComponent } from '@ntap/primeng';

@Component({
  selector: 'app-izvjestaj-common-item-view',
  template: ` <div class="custom-style">
    <ng-container ntapViewItemProvider>
      <ntap-prime-common-itemview></ntap-prime-common-itemview>
    </ng-container>
  </div>`,
  providers: [
    { provide: FORM_SERVICE_PROVIDER_TOKEN, useExisting: DynamicFormService }
  ]
})

/* Potreno samo zbog nefleksibilnosti NTAP-a, nikako nisam mogao koristiti dynamic form service za view specificnog reporta, i onda sam uzeo
    postojeci form service od item viewa od liste i iskoristio ga za specificni report itemview form service (rjesenje depdendency injection ovdje pa ga koristi gornja klaasa isto 
        + u token stavio taj posojeci form service)
  */
export class AppIzvjestajCommonItemViewComponent extends PrimeNGCommonItemViewComponent {
  constructor(
    protected override itemViewProvider: ItemViewProviderDirective<ItemView>,
    protected override dynamicFormService: DynamicFormService,
    protected override notificationService: NotificationService
  ) {
    super(itemViewProvider, dynamicFormService, notificationService);
  }

  override initializeControls(inputControlParams: InputControlData[]) {
    this.dynamicFormService.reInitializeFormGroup();
    inputControlParams.forEach((param) => {
      const validators = InputComponentUtil.getValidators(param);
      this.dynamicFormService.registerFormControl(
        param.attributeMetadata.name,
        { value: param.itemValue, disabled: param.disabled },
        validators
      );
    });
  }
}
